import React, { useContext } from 'react';
import { Row, Col, Container } from 'reactstrap';
import classNames from "classnames";
import { SessionContext } from '../../context/SessionContext';
import styles from './DealerInformation.module.css';
import BrandedIcon from '../../components/BrandingWhiteLabel/BrandedIcon';

const DealerInformation = () => {
    const sessionContext = useContext(SessionContext);
    const { accountName } = sessionContext;

    const DealerServiceInfo = ({ iconType, title, text, noMargin=false }) => {
        return (
            <Col xs='12' sm='6' md='6' lg='3' xl='3' className={classNames(styles.infoContainerHD, noMargin && styles.noMargin)}>
                <div>
                    <div className={styles.loginIconHD}>
                        <BrandedIcon
                            accountName={accountName}
                            iconType={iconType}
                        />
                    </div>
                    <div>
                        <h3 className='mb-2 text-left text-md-center text-lg-center'>
                            {title.split('<br>').map((line, index) => (
                                <span key={index}>
                                    {line}
                                    <br />
                                </span>
                            ))}
                        </h3>
                    </div>
                </div>
            </Col>
        );
    }

    return (
        <Container fluid className={styles.contentContainerOuterHD}>
            <Container className={styles.contentContainerHD}>
                <Row>
                    <Col>
                        <h1>It's Good To Be A Home Depot Dealer</h1>
                    </Col>
                </Row>
                <Row>                    
                    <Col sm='12' md='12' lg='12'>
                        <Row className={styles.serviceInfoContainer}>
                            <DealerServiceInfo
                                iconType="increasebenefits"
                                title='Increase Benefits, Greater Profits'
                            />
                            <DealerServiceInfo
                                iconType="standout"
                                 title="Stand Out with <br>Labor Coverage"
                            />
                            <DealerServiceInfo
                                iconType="partnerwithcustomer"
                                title="Partner with <br>Customers Long-term"
                            />
                            <DealerServiceInfo
                                iconType="minimalstartup"
                                title="Minimal Startup <br>and Overhead"
                                noMargin={true}
                            />
                        </Row>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

export default DealerInformation;